import axios from 'axios';
import { format, parseISO } from 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { customSelectStyle } from '../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle';
import { config } from '../../../../config/envs';
import { ACTIVE_TABS, BENEFITS_TABS_CONFIG, DATE_INITIAL } from './constants';
import BenefitsTable from './BenefitsTable';
import Abas from './Abas';

const todayIso = () => format(new Date(), 'yyyy-MM-dd');

export default function Creditos(props) {
  const [features, setFeatures] = useState([]);
  const [activeTab, setActiveTab] = useState(ACTIVE_TABS.BILHETAGEM);
  const [refreshKey, setRefreshKey] = useState(0);

  const [feature, setFeature] = useState(null);
  const [startFrom, setStartFrom] = useState(todayIso());
  const [valid, setValid] = useState(DATE_INITIAL);
  const [count, setCount] = useState(0);

  const getFeatures = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + '/subscription/features',
      );
      if (response.data && response.data.features) {
        setFeatures(response.data.features);
      }
    } catch (err) {
      toast.error('Ocorreu um erro ao carregar as features.');
    }
  }, [setFeatures]);

  const buildConfirmationMessage = () => {
    const featureName = feature?.description || feature?.name || 'funcionalidade';
    const startLabel = format(parseISO(startFrom), 'dd/MM/yyyy');
    const endLabel = format(parseISO(valid), 'dd/MM/yyyy');

    return (
      `Conceder crédito gratuito de ${count} unidade(s) para "${featureName}" ` +
      `de ${startLabel} até ${endLabel}?\n\n` +
      'Isso libera apenas essa funcionalidade no paywall — não altera a assinatura nem o acesso ao plano.'
    );
  };

  const addBenefit = async () => {
    if (
      feature === null ||
      count === '' ||
      !(Number(count) > 0) ||
      !startFrom ||
      !valid
    ) {
      alert('Preencha todos os campos.');
      return;
    }

    if (parseISO(startFrom) > parseISO(valid)) {
      alert('A data de início deve ser anterior ou igual à data de fim.');
      return;
    }

    if (!window.confirm(buildConfirmationMessage())) {
      return;
    }

    try {
      const response = await axios.post(
        config.app.adminBaseUrl + `/subscription/addBenefit`,
        {
          clientId: Number(props.cliente_id),
          featureId: feature.id,
          count: Number(count),
          startFrom,
          validUntil: valid,
        },
      );
      if (
        response.data &&
        response.data.success &&
        response.data.success === true
      ) {
        toast.success('Crédito gratuito concedido com sucesso!');
        setRefreshKey((prev) => prev + 1);
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          'Ocorreu um erro ao salvar, tente novamente.',
      );
    }
  };

  useEffect(() => {
    getFeatures();
  }, [getFeatures]);

  const activeTabConfig = BENEFITS_TABS_CONFIG[activeTab];

  return (
    <>
      <h2>Benefícios</h2>

      <Abas activeTab={activeTab} onTabChange={setActiveTab} />

      <BenefitsTable
        key={activeTab}
        cliente_id={props.cliente_id}
        path={activeTabConfig.path}
        errorMessage={activeTabConfig.errorMessage}
        refreshKey={refreshKey}
      />

      {!props.formik.values.deleted_at && (
        <>
          <h3>Conceder crédito gratuito</h3>
          <p className="text-muted mb-4">
            Libera uma funcionalidade específica por um período. Não estende a
            assinatura e não dá acesso ao restante do plano.
          </p>
          <div className="row">
            <div className="col-xl-12">
              <label className="form-label mb-0">Funcionalidade</label>
              <Select
                name="feature"
                theme={customSelectStyle}
                options={features}
                onChange={(value) => setFeature(value)}
                value={feature}
                placeholder="Selecione.."
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                isClearable={false}
                noOptionsMessage={() => <span>Sem resultados.</span>}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <label className="form-label mb-0">Quantidade</label>
              <input
                type="number"
                className="form-control"
                name="count"
                value={count}
                onChange={(evt) => setCount(evt.target.value)}
                minLength={0}
                min={0}
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-xl-6">
              <label className="form-label mb-0">Início da vigência</label>
              <input
                type="date"
                className="form-control"
                name="startFrom"
                value={startFrom}
                onChange={(evt) => setStartFrom(evt.target.value)}
              />
            </div>
            <div className="col-xl-6">
              <label className="form-label mb-0">Fim da vigência</label>
              <input
                type="date"
                className="form-control"
                name="valid"
                value={valid}
                onChange={(evt) => setValid(evt.target.value)}
              />
            </div>
          </div>

          <button
            type="button"
            className="btn btn-primary"
            onClick={addBenefit}
          >
            Conceder crédito gratuito
          </button>
        </>
      )}
    </>
  );
}
